import { render, staticRenderFns } from "./comp_SearchDialog.vue?vue&type=template&id=0b3f473b&scoped=true"
import script from "./comp_SearchDialog.vue?vue&type=script&lang=js"
export * from "./comp_SearchDialog.vue?vue&type=script&lang=js"
import style0 from "./comp_SearchDialog.vue?vue&type=style&index=0&id=0b3f473b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f473b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
